import { forwardRef } from "react";
import { WifiIcon } from "../icons/StatusIcons";

export const DeviceDisconnectedLogo = forwardRef(function DeviceDisconnectedLogo(
  props,
  ref
) {
  return <WifiIcon ref={ref} {...props} connected={false} />;
});

export const DeviceConnectedLogo = forwardRef(function DeviceConnectedLogo(
  props,
  ref
) {
  return <WifiIcon ref={ref} {...props} connected />;
});
